import { ResponsiveModal } from "../ResponsiveModal/ResponsiveModal";

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export default function IphoneInstructionsDialog({
  open,
  onOpenChange,
}: Props) {
  return (
    <ResponsiveModal
      open={open}
      onOpenChange={onOpenChange}
      title="How to Add to Home Screen"
    >
      <div className="grid gap-4">
        <div>To add the app to your home screen, follow the instructions.</div>
        <div>
          <h2 className="text-lg font-semibold">1. Open the Share Menu</h2>
          <p>Tap the Share button at the bottom of the screen.</p>
        </div>
        <div>
          <h2 className="text-lg font-semibold">
            2. Select “Add to Home Screen”
          </h2>
          <p>Scroll down in the menu and tap Add to Home Screen.</p>
        </div>
      </div>
    </ResponsiveModal>
  );
}
